import { NavLink } from 'react-router-dom';

// Overview + Posts are intentionally absent — publishing moved into the editor
// dashboard, and the operational landing redirects to /admin/sources (see App.jsx).
const links = [
  { to: '/admin/sources', label: 'Sources' },
  { to: '/admin/keywords', label: 'Keywords' },
  { to: '/admin/referrals', label: 'Referrals' },
  { to: '/admin/feedback', label: 'Feedback' },
];

function linkClass({ isActive }) {
  return [
    'whitespace-nowrap text-[13px] font-semibold px-4 py-3 border-b-[3px] transition-colors',
    isActive
      ? 'text-hxd-orange border-hxd-orange'
      : 'text-[#666] border-transparent hover:text-black',
  ].join(' ');
}

export default function AdminSubNav() {
  return (
    <div className="bg-white border-b border-hxd-border overflow-x-auto -mx-4 sm:-mx-6 px-4 sm:px-6 mb-6">
      <nav className="flex gap-0 min-w-max">
        {links.map((l) => (
          <NavLink key={l.to} to={l.to} end={l.end} className={linkClass}>
            {l.label}
          </NavLink>
        ))}
      </nav>
    </div>
  );
}
